"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerModel = void 0;
class CustomerModel {
    constructor(cache) {
        this.getCustomers = async () => (await this.cache
            .getArray(CustomerModel.CUSTOMERS_DB)
            .asPromise());
        this.updateCustomers = async (customers) => this.cache.setArray(CustomerModel.CUSTOMERS_DB, customers).asPromise();
        this.getCalorieBudget = async (customerId) => {
            return (await this.cache
                .getObject(this.calorieBudgetId(customerId))
                .asPromise());
        };
        this.setCalorieBudget = async (customerId, calorieBudget) => {
            await this.cache
                .setObject(this.calorieBudgetId(customerId), calorieBudget)
                .asPromise();
        };
        this.calorieBudgetId = (customerId) => {
            return `${CustomerModel.CALORIE_BUDGET_DB_PREFIX}.${customerId}`;
        };
        this.getFoodPreferences = async (customerId) => {
            return (await this.cache
                .getObject(this.foodPreferencesId(customerId))
                .asPromise());
        };
        this.setFoodPreferences = async (customerId, foodPreferences) => {
            await this.cache
                .setObject(this.foodPreferencesId(customerId), foodPreferences)
                .asPromise();
        };
        this.foodPreferencesId = (customerId) => {
            return `${CustomerModel.FOOD_PREFERENCES_DB_PREFIX}.${customerId}`;
        };
        this.cache = cache;
    }
}
exports.CustomerModel = CustomerModel;
CustomerModel.FOOD_PREFERENCES_DB_PREFIX = "Mock.Database.FOOD_PREFERENCES_DB";
CustomerModel.CALORIE_BUDGET_DB_PREFIX = "Mock.Database.CALORIE_BUDGET_DB";
CustomerModel.CUSTOMERS_DB = "Mock.Database.CUSTOMERS_DB";
exports.default = CustomerModel;
//# sourceMappingURL=CustomerModel.js.map